
/**
 * --- External Imports ---
 */
import { Field, Input, useFieldState } from "@ngt/forms-core";
import { FC } from "react";

/**
 * --- Internal Imports ---
 */
import { IFormField, TimeFormField } from "../../../../api/dtos/dtos";
import InputTimeField from "../InputTimeField";
import TextFieldControlLabel from "../labels/TextFieldControlLabel";
import { IFormFieldComponentProps } from "../types/FieldTypes";
import FieldErrors from "../utils/FieldErrors";


/**
 * --- Input Field ---
 */
interface IInputFieldTimeProps {
    field: IFormField;
}

const InputFieldTime: FC<IInputFieldTimeProps> = ({
    field
}) => {

    const { errors, touched } = useFieldState({ errors: true, touched: true });

    return (
        <TextFieldControlLabel 
            field={field}
            control={
                <Input
                    component={InputTimeField}
                    format='h:m a'
                    hasErrors={!!errors && touched}
                    sx={{
                        width: '100%',
                        "& input": {
                            padding: '8px 15px',
                        },
                    }}
                />
            }
        />
    )
}

/**
 * --- Time Field Export ---
 */
const FormFieldTime: FC<IFormFieldComponentProps<TimeFormField>> = ({
    field,
    form
}) => {
    return (
        <Field propertyPath={`${form.name}.${field.name}`}>
            <InputFieldTime field={field} />
            <FieldErrors />
        </Field>
    );
};

export default FormFieldTime;